exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhr {\n  background-color: #bababa;\n  border: 0;\n  height: 1px;\n  margin-bottom: calc(1rem + 10px);\n  margin-top: 0;\n  width: 100%;\n}\n#email[disabled] {\n  cursor: not-allowed;\n}\n", ""]);

// exports
